import { render, staticRenderFns } from "./photoLabel.vue?vue&type=template&id=70b39bea&scoped=true"
import script from "./photoLabel.vue?vue&type=script&lang=js"
export * from "./photoLabel.vue?vue&type=script&lang=js"
import style0 from "./photoLabel.vue?vue&type=style&index=0&id=70b39bea&prod&lang=scss&scoped=true"
import style1 from "./photoLabel.vue?vue&type=style&index=1&id=70b39bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b39bea",
  null
  
)

export default component.exports